import Model from '@/models/Model'

export default class AConfirmPay extends Model {
    resource() {
        return 'confirm_pay'
    }
}
